import AppConstants from "../constants/AppConstants";
import AssetLibraryModal from "./assetlibrary/AssetLibraryModal.jsx";
import PublishPanelModal from "./PublishPanelModal.jsx";
import SiteSettingsModal from "../app2components/modals/SiteSettings/SiteSettingsModal.jsx";
import PreviewPanelModal from "./PreviewPanelModal.jsx";
import DesignExportModal from "./DesignExportModal.jsx";
import ExportedDesignsModal from "./ExportedDesignsModal";
import BlogSetupModal from "./blogsetup/BlogSetupModal.jsx";
import DomainManagerModal from "./domainmanager/DomainManagerModal.jsx";
import DomainSetupModal from "./domainsetup/DomainSetupModal.jsx";
import DesignChooserModal from "./designchooser/DesignChooserModal.jsx";
import DomainSettingsModal from "./domainsettings/DomainSettingsModal";
import LayoutChooserModal from "./layoutchooser/LayoutChooserModal";
import SignupModal from "./demomode/SignupModal/SignupModal.jsx";
import UserBlogsModal from "./userblogs/UserBlogsModal.jsx";
import RendererLockInModal from "../app2components/modals/RendererLockInModal.jsx";

const modals = {
  [AppConstants.MODAL_DOMAIN_SETTINGS]: DomainSettingsModal,
  [AppConstants.MODAL_ASSET_LIBRARY]: AssetLibraryModal,
  [AppConstants.MODAL_SITE_SETTINGS]: SiteSettingsModal,
  [AppConstants.MODAL_DESIGN_PUBLISH]: PublishPanelModal,
  [AppConstants.MODAL_DESIGN_PREVIEW]: PreviewPanelModal,
  [AppConstants.MODAL_DESIGN_EXPORT]: DesignExportModal,
  [AppConstants.MODAL_USER_EXPORTS]: ExportedDesignsModal,
  [AppConstants.MODAL_BLOG_SETUP]: BlogSetupModal,
  [AppConstants.MODAL_DOMAIN_MANAGER]: DomainManagerModal,
  [AppConstants.MODAL_DOMAIN_SETUP]: DomainSetupModal,
  [AppConstants.MODAL_DESIGN_CHOOSER]: DesignChooserModal,
  [AppConstants.MODAL_LAYOUT_CHOOSER]: LayoutChooserModal,
  [AppConstants.MODAL_SIGNUP]: SignupModal,
  [AppConstants.MODAL_USER_BLOGS]: UserBlogsModal,
  [AppConstants.MODAL_RENDERER_LOCK_IN]: RendererLockInModal,
};

export default modals;

export const MODAL_LIST = Object.keys(modals);
